import { DateInputUsage } from './DateInputUsage'
import { DatePickerUsage } from './DatePickerUsage'
import { DateSelectUsage } from './DateSelectUsage'
import { DateTimePickerUsage } from './DateTimePickerUsage'
import { MonthDaysUsage } from './MonthDaysUsage'
import { MonthInputUsage } from './MonthInputUsage'
import { MonthSelectUsage } from './MonthSelectUsage'
import { TimeInputUsage } from './TimeInputUsage'
import { TimePickerUsage } from './TimePickerUsage'
import { WeekDaysUsage } from './WeekDaysUsage'
import { YearSelectUsage } from './YearSelectUsage'

export const DATE_TIME_MENU = [
  'Date & Time',
  [
    ['DateInput', DateInputUsage],
    ['DatePicker', DatePickerUsage],
    ['DateSelect', DateSelectUsage],
    ['DateTimePicker', DateTimePickerUsage],
    ['MonthDays', MonthDaysUsage],
    ['MonthInput', MonthInputUsage],
    ['MonthSelect', MonthSelectUsage],
    ['TimeInput', TimeInputUsage],
    ['TimePicker', TimePickerUsage],
    ['WeekDays', WeekDaysUsage],
    ['YearSelect', YearSelectUsage],
  ],
]
